/* istanbul ignore file */
import { createContext, useContext } from 'react';
import debug from 'debug';

debug.log = console.info.bind(console);

const NAMESPACE = 'jlp:plp';

const Context = createContext();

const instance = debug(NAMESPACE);

export const createDebugger = (name) => instance.extend(name);

export const useDebugger = () => useContext(Context);

export const Provider = ({ children, name, debug: localDebug }) => {
  const value = localDebug || createDebugger(name);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
